module.exports = __webpack_public_path__ + "static/media/food.19703c5b.jpg";